import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import { ModalButtonWrapper } from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';
import {
  ViewContainer,
  TitleSection,
  CheckListTitle,
  QuestionsSection,
  QuestionItem,
  QuestionHeader,
  QuestionTextWrapper,
  QuestionNumber,
  QuestionText,
  BadgeContainer,
  TypeBadge,
  RequiredBadge,
  OptionsContainer,
  OptionsTitle,
  OptionsList,
  OptionItem,
  OptionBullet,
  EmptyState,
  EmptyStateText,
} from '../declarationList.style';
import { ModalWrapper } from '../../EmailTemplate/emailTemplate.style';
import { ModalLabel } from '../../UserV2/user.style';

const QUESTION_TYPE_LABELS = {
  STRING: 'Text',
  NUMBER: 'Number',
  OPTION: 'Multiple Choice',
};

const ViewCheckListModal = ({ data, onClose }) => {
  if (!data) return null;

  // Handle both 'questions' and 'questionnaire' field names
  const questions = data.questions || data.questionnaire || [];

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      isUppercase={true}
      title={<IntlMessages id="modal.title.view.declaration" defaultMessage="View Declaration" />}
    >
      <ModalWrapper>
        <ViewContainer>
          <TitleSection>
            <ModalLabel>Title : </ModalLabel>
            <ModalLabel>{data.title}</ModalLabel>
          </TitleSection>

          {questions.length > 0 ? (
            <QuestionsSection>
              {questions.map((question, index) => (
                <QuestionItem key={question._id || question.id || index}>
                  <QuestionHeader>
                    <QuestionTextWrapper>
                      <QuestionNumber>Question {index + 1}</QuestionNumber>
                      <QuestionText>{question.question}</QuestionText>
                    </QuestionTextWrapper>

                    <BadgeContainer>
                      <TypeBadge type={question.type}>
                        {QUESTION_TYPE_LABELS[question.type] || question.type}
                      </TypeBadge>{' '}
                      {question.type === 'MEDIA' && (
                        <TypeBadge type={question.type}>{question.fileType}</TypeBadge>
                      )}
                      {question.required ? (
                        <RequiredBadge>Required</RequiredBadge>
                      ) : (
                        <RequiredBadge
                          style={{ backgroundColor: '#e5e7eb', color: '#6b7280', border: 'none' }}
                        >
                          Optional
                        </RequiredBadge>
                      )}
                    </BadgeContainer>
                  </QuestionHeader>

                  {question.type === 'OPTION' &&
                    question.options &&
                    question.options.length > 0 && (
                      <OptionsContainer>
                        <OptionsTitle>Available Options:</OptionsTitle>
                        <OptionsList>
                          {question.options.map((option, optIndex) => (
                            <OptionItem key={optIndex}>
                              <OptionBullet />
                              {option}
                            </OptionItem>
                          ))}
                        </OptionsList>
                      </OptionsContainer>
                    )}
                </QuestionItem>
              ))}
            </QuestionsSection>
          ) : (
            <EmptyState>
              <EmptyStateText>No questions found in this checklist.</EmptyStateText>
            </EmptyState>
          )}
        </ViewContainer>

        <ModalButtonWrapper>
          <Button varient="normal" onClick={onClose}>
            <IntlMessages id="modal.button.close" defaultMessage="Close" />
          </Button>
        </ModalButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
};

export default ViewCheckListModal;
